import { applyScaledTypeRamp } from "../utilities/typography";
import { neutralForegroundRest } from "../utilities/color";
const styles = {
    typography: {
        color: neutralForegroundRest,
        "margin-top": "0",
        "margin-bottom": "0",
        transition: "all 0.2s ease-in-out",
    },
    typography__1: Object.assign({}, applyScaledTypeRamp("t1")),
    typography__2: Object.assign({}, applyScaledTypeRamp("t2")),
    typography__3: Object.assign({}, applyScaledTypeRamp("t3")),
    typography__4: Object.assign({}, applyScaledTypeRamp("t4")),
    typography__5: Object.assign({}, applyScaledTypeRamp("t5")),
    typography__6: Object.assign({}, applyScaledTypeRamp("t6")),
    typography__7: Object.assign({}, applyScaledTypeRamp("t7")),
    typography__8: Object.assign({}, applyScaledTypeRamp("t8")),
    typography__9: Object.assign({}, applyScaledTypeRamp("t9")),
};
export default styles;
